<template>
  <!-- READ ONLY MODE -->

  <div class="option-section" v-if="mode === 'VIEW'">
    <div class="question-container">
      <span class="step" v-if="showStep">Step {{ question.stepSequence }}</span>
      <p class="question_body ql-editor p-0" v-html="question.formattedBody"></p>
    </div>
  </div>

  <!-- EDIT MODE -->

  <div v-else-if="mode == 'EDIT'">
    <div class="p-0">
      <div @click="isAddHelpEnabled = !isAddHelpEnabled" class="th-activity-question-type-custom-scale-edit">
        <span
          class="add-help-text"
          :class="{
            'right-position': activityDetails.customParticipantMessaging
          }"
          :style="{
            color: isAddHelpEnabled ? 'rgba(0, 0, 0, 0.2)' : ''
          }"
        >
          Add Help
        </span>
      </div>
      <div v-if="activityDetails.customParticipantMessaging" class="th-activity-question-type-custom-scale-edit" @click="toggleMessageTextInput">
        <span
          class="add-help-text"
          :style="{
            color: isAddMessageEnabled ? 'rgba(0, 0, 0, 0.2)' : ''
          }"
        >
          Add Message
        </span>
      </div>
      <quill-editor class="bg-white mt-30" v-model="question.formattedBody" :disabled="question.type === 'Default'" :options="commonProps.editorOptionForQuestion"></quill-editor>
    </div>
    <!-- help content -->
    <div v-if="isAddHelpEnabled">
      <h5 class="answer">Help</h5>
      <quill-editor class="bg-white mt-30 mb-20" v-model="question.helpContent" :options="editorOptionForHelp" v-on:change="helpCharacterLimitValidation($event)"></quill-editor>
    </div>
    <div v-if="isAddMessageEnabled && activityDetails.customParticipantMessaging" class="row add_message_div mb-30 mt-30">
      <div class="col-md-11 p-0">
        <h5 class="mt-10">Message</h5>
        <quill-editor v-model="question.messageBody" :options="editorOptionForMessage" class="bg-white mb-10 quill-score" @change="helpCharacterLimitValidation"></quill-editor>
      </div>
      <div class="col-md-1 p-0">
        <button class="btn btn-link color_red pl-0 pt-35" @click="toggleMessageTextInput(true)">
          <img src="static/img/delete.svg" />
        </button>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3 pl-0 pt-10 field-type">
        <h5>Field type</h5>
        <select
          class="selectpicker mt-5"
          v-model="question.fieldType"
          @change="onChangeFieldType"
          style="background-color: #fff;
                border: solid 2px #d3dfe4;
                width: 100%;
                color: #666669;"
        >
          <option class="validated-entry-option" value="email">Email</option>
          <option value="opentext">Open text</option>
          <option value="phonenumber">Phone number</option>
          <option value="websiteurl">Website URL</option>
        </select>
      </div>
      <div class="col-md-9 validated_scorebox p-0">
        <div class="row pl-15">
          <div class="pl-0 pt-10 fs-15 col-md-3 multiple_line_entry" v-if="this.fieldTypeFlag">
            <h5>Validation settings</h5>
            <label class>
              <input type="checkbox" v-model="question.isMultipleLineEntry" />
              <span class="text-align">Multiple Line Entry</span>
            </label>
          </div>
          <div class="fs-15 pt-38 col-md-3 secure_entry" v-if="this.fieldTypeFlag">
            <label class>
              <input type="checkbox" v-model="question.isSecureEntry" />
              <span class="text-align">Secure Entry</span>
            </label>
          </div>
          <div class="fs-15 pt-38 col-md-3 allow_autocorrect" v-if="this.fieldTypeFlag">
            <label class>
              <input type="checkbox" v-model="question.isAllowAutocorrect" />
              <span class="text-align">Allow Autocorrect</span>
            </label>
          </div>

          <div class="col-md-2 mt-11">
            <h5 class="score_text">Score</h5>
            <integer-plusminus :min="0" :max="999" :step="1" :vertical="false" :disabled="activityDetails && activityDetails.canScoreResponses == false" formName="score" class="score_input" v-model="question.score">
              <input v-model.number="question.score" oninput="javascript:this.value = Math.abs(this.value); this.value = Math.round(this.value); if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" maxlength="3" value="999" type="number" class="integer-plus-minus-input text-left pl-4" />
            </integer-plusminus>
          </div>
        </div>
        <div class="row mb-20 pl-15">
          <div class="col-md-2 p-0 mt-40 nol" v-if="this.fieldTypeFlag && question.isMultipleLineEntry">
            <h5 class="">Number of Lines</h5>
          </div>
          <div class="col-md-2 p-0 pt-10" v-if="this.fieldTypeFlag && question.isMultipleLineEntry">
            <integer-plusminus :min="2" :max="99" :step="1" :vertical="false" :disabled="activityDetails && activityDetails.canScoreResponses == false" formName="numberOfLines" class="numberOfLines_input mt-20" v-model="question.numberOfLines">
              <input v-model.number="question.numberOfLines" type="number" oninput="javascript:this.value = Math.abs(this.value); this.value = Math.round(this.value); if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" maxlength="3" value="999" class="integer-plus-minus-input"
            /></integer-plusminus>
          </div>
          <div class="fs-15 pt-30 col-md-4" v-if="this.fieldTypeFlag && question.isMultipleLineEntry">
            <h5></h5>
            <label class>
              <input type="checkbox" v-model="question.isAllowUsertoAddAdditional" />
              <span class="text-align">Allow User to Add Additional Lines</span>
            </label>
          </div>
        </div>
      </div>
      <div class="clearfix"></div>
      <hr class="m-0 pt-15" v-if="this.fieldTypeFlag" />
      <b-row class="pt-15 pl-35 fs-13" v-if="this.fieldTypeFlag">
        <b-col cols="12" lg="4" class="pt-10 pl-0">
          <div class="bright">
            <div class="pb-10">
              <h5 class="">Allowed Characters</h5>
            </div>
            <b-row>
              <b-form-checkbox v-model="question.lettersAllowed" id="textAreaLettersAllowed" class="pl-0"> </b-form-checkbox>
              <label for="textAreaLettersAllowed" class="pl-8 fs-15 pt-2 text-align allowed_char_label">Letters(abc)</label>
            </b-row>
            <b-row>
              <b-form-checkbox v-model="question.numbersAllowed" id="textAreaNumbersAllowed" class="pl-0"> </b-form-checkbox>
              <label for="textAreaNumbersAllowed" class="pl-8 fs-15 pt-2 text-align allowed_char_label">Numbers(123)</label>
            </b-row>
            <b-row>
              <b-form-checkbox v-model="question.specialCharactersAllowed" id="textAreaSpecialCharsAllowed" class="pl-0"> </b-form-checkbox>
              <label for="textAreaSpecialCharsAllowed" class="pl-8 fs-15 pt-2 text-align allowed_char_label">Special characters(!@#)</label>
            </b-row>
          </div>
        </b-col>
        <!-- For text constraints -->
        <b-col cols="12" lg="6" class="pt-10 pl-4" v-if="question.lettersAllowed || question.specialCharactersAllowed">
          <div class="pb-10 fs-13">
            <h5 class="">Character Text</h5>
          </div>
          <b-row class="mt-15">
            <b-col cols="12" lg="6" class="pl-0">
              <label class>
                <input type="checkbox" v-model="question.minCharsFlag" />
                <span for="scaleMinCharacters" class="pl-8 fs-15 allowed_char_label">Min characters</span>
              </label>
              <div class="col-lg-12 pull-right" v-if="question.minCharsFlag">
                <b-form-input
                  type="number"
                  min="1"
                  class="fs-15 form-control field-h40 mt-10"
                  placeholder="0"
                  v-model="question.minChars"
                  size="sm"
                  v-validate="{ regex: /^\d+$/, required: true }"
                  name="charMin"
                  v-bind:class="{
                    input: true,
                    'is-danger': errors.has('charMin')
                  }"
                  autocomplete="off"
                >
                </b-form-input>
              </div>
            </b-col>
            <b-col cols="12" lg="6" class="pl-0">
              <label class>
                <input type="checkbox" v-model="question.maxCharsFlag" />
                <span for="scaleMaxCharacters" class="pl-8 fs-15 allowed_char_label">Max characters</span>
              </label>
              <div v-if="question.maxCharsFlag" class="col-lg-12 pull-right">
                <b-form-input
                  type="number"
                  class="fs-15 form-control field-h40 mt-10"
                  min="0"
                  placeholder="200"
                  v-model="question.maxChars"
                  size="sm"
                  v-validate="{ regex: /^\d+$/, required: true }"
                  name="charMax"
                  v-bind:class="{
                    input: true,
                    'is-danger': errors.has('charMax')
                  }"
                  autocomplete="off"
                >
                </b-form-input>
              </div>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { IntegerPlusminus } from "vue-integer-plusminus";
import activityStepCustomMessage from "@/mixins/activity-step-custom-message";
import { quillEditor } from "vue-quill-editor";

export default {
  name: "ActivityStepValidatedEntry",
  mixins: [activityStepCustomMessage],
  data() {
    return {
      fieldTypeFlag: false,
      isAddHelpEnabled: false
    };
  },
  props: {
    question: {},
    showStep: { type: Boolean },
    mode: {
      default: "VIEW"
    },
    activityDetails: {},
    commonProps: {},
    editorOptionForHelp: {
      type: Object
    }
  },
  watch: {
    isAddHelpEnabled() {
      this.question.isAddHelpEnabled = this.isAddHelpEnabled;
    }
  },
  components: {
    IntegerPlusminus,
    quillEditor
  },
  mounted() {
    this.isAddHelpEnabled = this.question.isAddHelpEnabled;
    this.init();
  },
  methods: {
    helpCharacterLimitValidation(event, maxCount = 250) {
      const helpContent = event.quill;
      if (event.text.length > maxCount) {
        this.$toastr.error(`Character limit cannot exceed ${maxCount}.`);
      }
      helpContent.deleteText(maxCount, helpContent.getLength());
    },
    stripHtml(content) {
      const temporalDivElement = document.createElement("div");
      temporalDivElement.innerHTML = content;
      return temporalDivElement.innerText;
    },
    init() {
      if (!this.question.id) {
        this.$set(this.question, "fieldType", "email");
        this.$set(this.question, "lettersAllowed", true);
        this.$set(this.question, "numbersAllowed", true);
        this.$set(this.question, "specialCharactersAllowed", true);
        this.$set(this.question, "isAllowUsertoAddAdditional", true);
        this.$set(this.question, "score", 0);
        this.$set(this.question, "numberOfLines", 3);
        this.$set(this.question, "decimalLimit", 2);
      } else {
        if (this.question.fieldType == "opentext") {
          this.fieldTypeFlag = true;
        } else {
          this.fieldTypeFlag = false;
        }
        this.$set(this.question, "fieldType", this.question.fieldType);
        this.$set(this.question, "lettersAllowed", this.question.lettersAllowed);
        this.$set(this.question, "numbersAllowed", this.question.numbersAllowed);
        this.$set(this.question, "specialCharactersAllowed", this.question.specialCharactersAllowed);
        this.$set(this.question, "isAllowUsertoAddAdditional", this.question.isAllowUsertoAddAdditional);
        this.$set(this.question, "maxChars", this.question.maxChars);
        this.$set(this.question, "maxLimit", this.question.maxLimit);
        this.$set(this.question, "minChars", this.question.minChars);
        this.$set(this.question, "minLimit", this.question.minLimit);
        this.$set(this.question, "numberOfLines", this.question.numberOfLines);
        this.$set(this.question, "decimalLimit", this.question.decimalLimit);
      }
    },
    onChangeFieldType() {
      if (this.question.fieldType == "opentext") {
        this.fieldTypeFlag = true;
      } else {
        this.fieldTypeFlag = false;
      }
    },
    checkQuestionValidity() {
      const question = this.question;
      const errorObj = { isValid: true };

      if (this.stripHtml(question.formattedBody) === "") {
        errorObj.msg = "Step is required.";
        errorObj.isValid = false;
        return errorObj;
      }
      if (question.isAddHelpEnabled && (!question.hasOwnProperty("helpContent") || this.stripHtml(question.helpContent).trim() === "")) {
        errorObj.isValid = false;
        errorObj.msg = "Help text is required for this step.";
        return errorObj;
      }
      if (question.isAddMessageEnabled && (!question.hasOwnProperty("messageBody") || this.stripHtml(question.messageBody).trim() === "")) {
        errorObj.isValid = false;
        errorObj.msg = "Message text is required for this step.";
        return errorObj;
      }

      if (question.fieldType == "opentext") {
        // validate min, max value
        if (!question.lettersAllowed && !question.specialCharactersAllowed && !question.numbersAllowed) {
          errorObj.msg = "You have to select atleast any one of the allowed characters.";
          errorObj.isValid = false;
          return errorObj;
        } else if (question.lettersAllowed || question.specialCharactersAllowed) {
          if (question.minCharsFlag && question.maxCharsFlag) {
            if (parseInt(question.maxChars, 0) >= 0 && parseInt(question.minChars, 0) >= 0 && parseInt(question.maxChars, 0) <= parseInt(question.minChars, 0)) {
              errorObj.msg = "Max value cannot be less than or equal to min value.";
              errorObj.isValid = false;
              return errorObj;
            } else if (question.minChars == "" || question.minChars == undefined) {
              errorObj.msg = "Min Characters value is required.";
              errorObj.isValid = false;
              return errorObj;
            } else if (question.minChars == 0) {
              errorObj.msg = "Min Characters value is required.";
              errorObj.isValid = false;
              return errorObj;
            } else if (question.maxChars == "" || question.maxChars == undefined) {
              errorObj.msg = "Max Characters value is required.";
              errorObj.isValid = false;
              return errorObj;
            }
          } else if (question.minCharsFlag) {
            if (question.minChars == "" || question.minChars == undefined) {
              errorObj.msg = "Min Characters value is required.";
              errorObj.isValid = false;
              return errorObj;
            }
            if (question.minChars == 0) {
              errorObj.msg = "Min Characters value is required.";
              errorObj.isValid = false;
              return errorObj;
            }
          } else if (question.maxCharsFlag) {
            if (question.maxChars == "" || question.maxChars == undefined) {
              errorObj.msg = "Max Characters value is required.";
              errorObj.isValid = false;
              return errorObj;
            }
          }
          // check for values in case of only numbers is selected
        } else {
          if (question.minLimitFlag && question.maxLimitFlag) {
            if (parseInt(question.maxLimit, 0) >= 0 && parseInt(question.minLimit, 0) >= 0 && parseInt(question.maxLimit, 0) <= parseInt(question.minLimit, 0)) {
              errorObj.msg = "Max value cannot be less than or equal to min value.";
              errorObj.isValid = false;
              return errorObj;
            } else if (question.minLimit == "") {
              errorObj.msg = "Min limit value is required.";
              errorObj.isValid = false;
              return errorObj;
            } else if (question.maxLimit == "") {
              errorObj.msg = "Max limit value is required.";
              errorObj.isValid = false;
              return errorObj;
            } else if (question.decimalLimit == "") {
              errorObj.msg = "Decimal limit value is required.";
              errorObj.isValid = false;
              return errorObj;
            }
          } else if (question.minLimitFlag) {
            if (question.minLimit == "") {
              errorObj.msg = "Min Characters value is required.";
              errorObj.isValid = false;
              return errorObj;
            }
          } else if (question.maxLimitFlag) {
            if (question.maxLimit == "") {
              errorObj.msg = "Max Characters value is required.";
              errorObj.isValid = false;
              return errorObj;
            }
          } else if (question.decimalLimitFlag) {
            if (question.decimalLimit == "") {
              errorObj.msg = "Decimal limit value is required.";
              errorObj.isValid = false;
              return errorObj;
            }
          }
        }
      }

      return { isValid: true };
    }
  }
};
</script>

<style scoped lang="scss">
.radio-option {
  margin: 0px;
  label {
    padding-left: 5px;
  }
}
.primaryBackGround {
  background-color: white;
  padding: 20px;
}

.formTextArea {
  position: relative;
  border: 0.5px solid lightgray;
  border-radius: 2px;
}

.sequence-style {
  position: absolute;
  top: 20px;
}

.is-danger {
  border-color: #ff4848;
}

.error-style {
  font-size: 12px;
  color: #ff4848;
  padding-bottom: 5px;
}

.bright {
  border-right: 0.5px solid lightgrey;
}

.field-select {
  width: 80px;
  margin-left: -12px;
}

/deep/.vue-switcher-theme--custom.vue-switcher-color--blue div {
  background-color: #1e8fe1;
  height: 9px;
  width: 33px;
}

/deep/.vue-switcher-theme--custom.vue-switcher-color--blue div:after {
  background-color: #ffffff;
  border: 1px solid #1e8fe1;
  height: 15px;
  width: 15px;
  margin-left: -15px;
}

/deep/.vue-switcher-theme--custom.vue-switcher-color--blue.vue-switcher--unchecked div {
  background-color: #d5d7dc;
  height: 9px;
  width: 33px;
}

/deep/.vue-switcher-theme--custom.vue-switcher-color--blue.vue-switcher--unchecked div:after {
  background-color: #ffffff;
  border: 1px solid #1e8fe1;
  height: 15px;
  width: 15px;
}
.col-md-3.pl-0.pt-10.field-type {
  width: 21.5%;
}
.col-md-3.multiple_line_entry {
  width: 21%;
}
.col-md-3.secure_entry {
  width: 19%;
}
.col-md-2.number_of_line {
  width: 13%;
}
.col-md-2.no_of_lines_input {
  width: 14%;
}
.allowed_char_label {
  position: relative;
  top: -7px;
}
.integer-plus-minus-input {
  width: 2rem;
  border: none;
  text-align: center;
}
.selectpicker option {
  font-weight: 600;
}
.validated_scorebox {
  left: 0px;
}
.add-help-text {
  right: 533px;
  padding: 12px 13px;
  top: -38px;

  &.right-position {
    right: 637px;
  }
}
</style>
